import { Component, ElementRef, Input, ViewChild, ChangeDetectionStrategy } from '@angular/core';

import { BaseComponent } from '../base/base-component.component';
import { HelperService } from '../services/helper.service';
import { PopupPosition } from '../models/PopupPosition';
import { ResizedEvent } from '../directives/resize.directive';

@Component({
  standalone: false,
  selector: 'daui-signposts',
  templateUrl: './signposts.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./signposts.component.less'],
})
export class SignpostsComponent extends BaseComponent {
  @Input() minWidth = 20;
  @Input() maxHeight = 20;
  @Input() position: PopupPosition = PopupPosition.BottomLeft;

  @ViewChild('content', { static: false })
  content: ElementRef;

  currentHeight: number;

  constructor(
    private helperService: HelperService,
    private elementRef: ElementRef,
  ) {
    super();
  }

  protected onInit(): void {}

  protected onDestroy(): void {}

  onResize(event: ResizedEvent) {
    this.currentHeight =
      event.newHeight < this.maxHeight * 10 ? event.newHeight / 10 : this.maxHeight;
  }
}
